module.exports = __webpack_public_path__ + "static/img/background2.cf62d83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/background2.jpg
// module id = RrCu
// module chunks = 0